import type { VoidFunctionComponent } from 'react';
import { ButtonGroup, NavigationButton } from '../../../../generic/Button';
import FromNow from '../../../../generic/FromNow';
import { icons } from '../../../../generic/Icon';
import List from '../../../../generic/List';

type Props = {
  id: number;
  releaseGroupId: number;
  title: string;
  createdAt: Date;
};

/**
 * ReleaseGroupReleasesListRow is a single row in the list of releases,
 * representing a single release.
 */
const ReleaseGroupReleasesListRow: VoidFunctionComponent<Props> = ({
  id,
  releaseGroupId,
  title,
  createdAt,
}) => (
  <List.RowContainer>
    <List.Row
      hasTightPadding
      isInteractive={false}
      right={
        <ButtonGroup>
          <NavigationButton
            to={`/projects/group/${releaseGroupId}/releases/${id}/edit`}
            type="secondary"
            size="medium"
            icon={icons.edit}
            testId={`edit-release-button--${id}`}
          >
            Edit
          </NavigationButton>
          <NavigationButton
            to={`/projects/group/${releaseGroupId}/releases/${id}/clone`}
            type="secondary"
            size="medium"
            icon={icons.cloneO}
            testId={`clone-release-button--${id}`}
          >
            Clone
          </NavigationButton>
        </ButtonGroup>
      }
    >
      <List.RowTitle>{title}</List.RowTitle>
      <List.RowSubtitle>
        <FromNow date={createdAt} />
      </List.RowSubtitle>
    </List.Row>
  </List.RowContainer>
);

export default ReleaseGroupReleasesListRow;
